import httpClient from '@/api/httpClient';

export const getNexultraMarketingCampaign = deliveryCountry => {
  const params = new URLSearchParams({ country: deliveryCountry });

  return httpClient.get(`/api/webShop/temporaryMarketingCampaign/nexultraL1?${params}`);
};
